import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../service/storage.service';
import { ApiService } from '../../service/api.service';
import { ToolsService } from '../../service/tools.service';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
declare var google: any;

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {

  track: any;
  geocoder: any;
  lat: any = 0;
  lon: any = 0;
  zoom: any = 11;
  showRemove = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private api: ApiService,
    private tools: ToolsService,
    public mapsApiLoader: MapsAPILoader
  ) {
    this.route.params.subscribe( params => {
      this.track = this.storage.getTrack( params[ 'track' ] );

      if ( this.track != null ) {
        if ( this.track[ 'lastEvent' ][ 'position' ] ) {
          this.lat = this.track[ 'lastEvent' ][ 'position' ]['lat'];
          this.lon = this.track[ 'lastEvent' ][ 'position' ]['lon'];
        }
        this.showRemove = true;
      } else {
        this.api.getTrack( params['track'] ).subscribe( data => {
          this.track = data;
          this.lat = this.track[ 'lastEvent' ][ 'position' ]['lat'];
          this.lon = this.track[ 'lastEvent' ][ 'position' ]['lon'];
          this.showRemove = false;
        } );
      }
    } );
  }

  ngOnInit() { }

  getIcon( type ) {
    return this.tools.getIcon( type );
  }

  getColor ( type ) {
    return this.tools.getColor( type );
  }

  getQRCode( track ) {
    return 'https://br.qr-code-generator.com/phpqrcode/getCode.php?cht=qr&chl=' + track[ 'track' ] + '&chs=180x180&choe=UTF-8&chld=L|0';
  }

  removeTrack( track ) {
    this.storage.removeTrack( track[ 'track' ] );
    this.router.navigateByUrl('/');
  }

}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/app/view/view.component.ts